module.exports = __webpack_public_path__ + "static/media/illuminate-thumbnail.8fe757a4.png";